var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ShadowlessElement, WithDisposable } from '@blocksuite/lit';
import { flip, offset } from '@floating-ui/dom';
import { html } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';
import { styleMap } from 'lit/directives/style-map.js';
import { HoverController } from '../_common/components/hover/controller.js';
import { toggleBookmarkEditModal } from './components/modal/bookmark-edit-modal.js';
import { refreshBookmarkUrlData } from './utils.js';
let DocBookmarkBlockComponent = class DocBookmarkBlockComponent extends WithDisposable(ShadowlessElement) {
    constructor() {
        super(...arguments);
        this._showCaption = false;
        this._onToolbarSelected = type => {
            if (type === 'caption') {
                this._showCaption = true;
                this.updateComplete
                    .then(() => this.captionElement.input.focus())
                    .catch(console.error);
            }
            if (type === 'edit') {
                toggleBookmarkEditModal(this.block);
            }
            if (type === 'reload') {
                refreshBookmarkUrlData(this.block).catch(console.error);
            }
            this._optionsAbortController?.abort();
        };
        this._whenHover = new HoverController(this, ({ abortController }) => {
            this._optionsAbortController = abortController;
            return {
                template: html `<style>
          :host {
            z-index: 1;
          }
        </style>
        <bookmark-toolbar
          .model=${this.model}
          .onSelected=${this._onToolbarSelected}
          .host=${this}
          .abortController=${abortController}
          .std=${this.block.std}
        ></bookmark-toolbar>`,
                computePosition: {
                    referenceElement: this,
                    placement: 'top-end',
                    middleware: [flip(), offset(4)],
                    autoUpdate: true,
                },
            };
        });
    }
    get model() {
        return this.block.model;
    }
    get root() {
        return this.block.host;
    }
    connectedCallback() {
        super.connectedCallback();
        if (!!this.model.caption && this.model.caption.length > 0) {
            this._showCaption = true;
        }
        this.disposables.add(this.root.selection.slots.changed.on(() => this.requestUpdate()));
    }
    render() {
        return html `<div
      ${ref(this._whenHover.setReference)}
      style=${styleMap({
            width: '100%',
            margin: '18px 0',
            position: 'relative',
        })}
    >
      <bookmark-card .bookmark=${this.block}></bookmark-card>
      <bookmark-caption
        .bookmark=${this.block}
        .display=${this._showCaption}
        @blur=${() => {
            if (!this.model.caption) {
                this._showCaption = false;
            }
        }}
      ></bookmark-caption>
      ${this.block.selected?.is('block')
            ? html `<affine-block-selection></affine-block-selection>`
            : null}
    </div>`;
    }
};
__decorate([
    property({ attribute: false })
], DocBookmarkBlockComponent.prototype, "block", void 0);
__decorate([
    state()
], DocBookmarkBlockComponent.prototype, "_showCaption", void 0);
__decorate([
    query('bookmark-caption')
], DocBookmarkBlockComponent.prototype, "captionElement", void 0);
DocBookmarkBlockComponent = __decorate([
    customElement('affine-doc-bookmark')
], DocBookmarkBlockComponent);
export { DocBookmarkBlockComponent };
//# sourceMappingURL=doc-bookmark-block.js.map